import { graphql } from 'gatsby';
import React from 'react';
import { InformationPanel } from '../components/information-panel';
import { useLocalize } from '../components/localize-context';
import { Seo } from '../components/seo';

export default function Reminder({ data: { prismicReminder } }) {
  const localize = useLocalize();

  return (
    <>
      <Seo title={localize('Reminders')} />
      <div className="container mx-auto py-6 px-4">
        <h1 className="text-5xl text-center mb-4">{localize('Reminders')}</h1>
        {prismicReminder ? (
          <InformationPanel>
            <div
              className="rich-text"
              dangerouslySetInnerHTML={{
                __html: prismicReminder.data.content.html,
              }}
            />
          </InformationPanel>
        ) : (
          <p>Missing content</p>
        )}
      </div>
    </>
  );
}

export const pageQuery = graphql`
  query ReminderQuery($lang: String!) {
    prismicReminder(lang: { eq: $lang }) {
      data {
        content {
          html
        }
      }
    }
  }
`;
